var map = {
	"./Hyundai-ioniq6.jpg": "1fa9",
	"./Kia-ev6.jpg": "a251",
	"./VW-idbuzz.jpg": "4074",
	"./bmw-ix-xdrive40.jpg": "0024",
	"./bmw-ix-xdrive50.jpg": "b76f",
	"./mb-eqesuv.jpg": "df7c5",
	"./slide-1.jpg": "1c4e",
	"./slide-2.jpg": "162e",
	"./slide-3.jpg": "07f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";